/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PaymentRequestQuickViewContent_statusTypes$ref: FragmentReference;
declare export opaque type PaymentRequestQuickViewContent_statusTypes$fragmentType: PaymentRequestQuickViewContent_statusTypes$ref;
export type PaymentRequestQuickViewContent_statusTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: PaymentRequestQuickViewContent_statusTypes$ref,
|};
export type PaymentRequestQuickViewContent_statusTypes$data = PaymentRequestQuickViewContent_statusTypes;
export type PaymentRequestQuickViewContent_statusTypes$key = {
  +$data?: PaymentRequestQuickViewContent_statusTypes$data,
  +$fragmentRefs: PaymentRequestQuickViewContent_statusTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PaymentRequestQuickViewContent_statusTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '20bffa5a8f686e62d4674ac81aa5ac93';
module.exports = node;
